import React from "react";

const IconsSelect: React.FC<{ type: string }> = ({ type }) => {
  const isLocal = window.location.hostname === "localhost";
  const iconBase = isLocal ? "../../assets/icons/" : "/global/CCBContactus/eppublic/contactus/icons/";
  const iconMap: Record<string, string> = {
    barChartDollar: "bar-chart-dollar-bill.svg",
    dollarBillStack: "dollar-bill-stack.svg",
    dollarRefresh: "dollar-refresh.svg",
    flshOn: "flash-on.svg",
    globe: "globe.svg",
    green: "green.svg",
    help: "help.svg",
    latam: "latam.svg",
  }

  const readableAlt = (type: string) => {
    return `Icon representing ${type.replace(/([A-Z])/g, " $1").toLowerCase()}`
  }

  const filename = iconMap[type];
  if (!filename) return null;

  const src = `${iconBase}${filename}`;

  return (
    <img
      className="business-icon"
      style={{ width: "100%", maxWidth: "2.5rem" }}
      src={src}
      aria-hidden="true"
      alt={readableAlt(type)}
    />
  );
};

export default IconsSelect;
